module.exports = __webpack_public_path__ + "static/media/Gif 1.0e12be67.gif";